module.exports = __webpack_public_path__ + "img/6inComplete_I_small2-min.b34be74f.png";